import {createReducer} from "typesafe-actions";
import {getNotCalculatedStepsAsync} from "../actions";
import {StepForm} from "../../../models/api/codegen/code";

export const steps = createReducer([] as StepForm[])
    .handleAction(getNotCalculatedStepsAsync.success, (state, action) => action.payload);

export const stepsLoaded = createReducer(false)
    .handleAction(getNotCalculatedStepsAsync.success, () => true);